<template>
  <v-container class="pa-0">
    <v-app-bar color="transparent" class="elevation-0 pa-0 page-header-toolbar">
      <page-header-title :title="page_title"></page-header-title>

      <v-spacer></v-spacer>

      <v-btn color="info" type="button" @click="$router.go(-1)" class="darken-2">
        <v-icon small left>fas fa-arrow-left</v-icon>
        {{ $t("global.back") }}
      </v-btn>
      <v-btn v-if="options.edit == false" @click="toggleEdit()" color="info" class="button_text--text darken-2">
        <v-icon small left>fas fa-edit</v-icon>
        {{ $t("global.edit") }}
      </v-btn>
      <v-btn v-if="options.edit == true" @click="toggleEdit()" class="button_text--text red darken-2">
        <v-icon small left>fas fa-times</v-icon>
        {{ $t("global.cancel") }}
      </v-btn>
    </v-app-bar>
    <v-container grid-list-md>
      <v-card>
        <v-tabs color="secondary" slider-color="black">
          <v-tab key="profile">
            {{ $t("users.edit.personal_info") }}
          </v-tab>
          <v-tab-item key="profile">
            <v-card>
              <v-form ref="form" data-vv-scope="user-form">
                <v-card-text>
                  <v-layout v-if="options.edit == true" v-bind="binding">
                    <v-flex>
                      <v-text-field
                        v-model="user.person.first_name"
                        class="required-field"
                        v-validate="'required'"
                        :label="$t('users.first_name')"
                        :error-messages="errors.collect('user-form.person.first_name')"
                        data-vv-name="first_name"
                        autocomplete="new-password"
                      ></v-text-field>
                    </v-flex>
                    <v-flex>
                      <v-text-field
                        v-model="user.person.middle_name"
                        :label="$t('users.middle_name')"
                        :error-messages="errors.collect('user-form.person.middle_name')"
                        data-vv-name="middle_name"
                        autocomplete="new-password"
                      ></v-text-field>
                    </v-flex>
                    <v-flex>
                      <v-text-field
                        v-model="user.person.last_name"
                        class="required-field"
                        v-validate="'required'"
                        :label="$t('users.last_name')"
                        :error-messages="errors.collect('user-form.person.last_name')"
                        data-vv-name="last_name"
                        autocomplete="new-password"
                      ></v-text-field>
                    </v-flex>
                    <v-flex>
                      <v-text-field
                        v-model="user.email"
                        :label="$t('users.email')"
                        :error-messages="errors.collect('user-form.user.email')"
                        data-vv-name="email"
                        autocomplete="new-password"
                      ></v-text-field>
                    </v-flex>
                    <v-flex>
                      <v-text-field
                        v-model="user.person.mobile"
                        :label="$t('users.mobile')"
                        :error-messages="errors.collect('user-form.person.mobile')"
                        data-vv-name="mobile"
                        name="mobile"
                        v-validate="'no_space'"
                        @blur="phoneNoSpace"
                        autocomplete="new-password"
                      ></v-text-field>
                    </v-flex>
                    <br />
                    <v-btn color="success" @click="update('user-form')" class="darken-2">
                      <v-icon small left>fas fa-save</v-icon>
                      {{ $t("global.save") }}
                    </v-btn>
                  </v-layout>

                  <v-layout v-if="options.edit == false" v-bind="binding">
                    <v-flex>
                      <v-text-field
                        v-model="user.person.first_name"
                        :label="$t('users.first_name')"
                        data-vv-name="first_name"
                        :readonly="true"
                        autocomplete="new-password"
                      ></v-text-field>
                    </v-flex>
                    <v-flex>
                      <v-text-field
                        v-model="user.person.middle_name"
                        :label="$t('users.middle_name')"
                        data-vv-name="middle_name"
                        :readonly="true"
                        autocomplete="new-password"
                      ></v-text-field>
                    </v-flex>
                    <v-flex>
                      <v-text-field
                        v-model="user.person.last_name"
                        :label="$t('users.last_name')"
                        data-vv-name="last_name"
                        :readonly="true"
                        autocomplete="new-password"
                      ></v-text-field>
                    </v-flex>
                    <v-flex>
                      <v-text-field
                        v-model="user.email"
                        :label="$t('users.email')"
                        data-vv-name="email"
                        :readonly="true"
                        autocomplete="new-password"
                      ></v-text-field>
                    </v-flex>
                    <v-flex>
                      <v-text-field
                        v-model="user.person.mobile"
                        :label="$t('users.mobile')"
                        data-vv-name="mobile"
                        :readonly="true"
                        autocomplete="new-password"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-form>
            </v-card>
          </v-tab-item>
          <v-tab key="passwordt">
            {{ $t("users.changepass") }}
          </v-tab>
          <v-tab-item key="passwordt">
            <v-card>
              <v-form ref="form_password" data-vv-scope="password-form">
                <v-card-text row wrap>
                  <v-flex>
                    <v-text-field
                      v-model="old_password"
                      v-validate="!this.id ? 'required' : ''"
                      :label="$t('users.edit.old_pass')"
                      :error-messages="errors.collect('password-form.user.old_pass')"
                      data-vv-name="old_password"
                      type="password"
                      autocomplete="new-password"
                    ></v-text-field>
                    <br />
                    <v-text-field
                      v-model="password"
                      data-vv-name="new_password"
                      class="required-field"
                      v-validate="'required'"
                      :label="$t('users.edit.new_pass')"
                      :error-messages="errors.collect('password-form.new_password')"
                      type="password"
                      autocomplete="new-password"
                    ></v-text-field>
                    <br />
                    <v-text-field
                      v-model="password_confirmation"
                      class="required-field"
                      v-validate="'required|confirmed:new_password'"
                      :label="$t('users.edit.confirm_pass')"
                      :error-messages="errors.collect('password-form.confirm_pass')"
                      data-vv-name="password_confirmation"
                      data-vv-as="new_password"
                      ref="password"
                      type="password"
                      autocomplete="new-password"
                    ></v-text-field>
                    <label v-if="isPasswordMatch == false" class="red--text text--darken-2">{{ $t("users.edit.password_no_match") }}</label>
                    <br />
                    <v-btn color="success" class="button_text--text darken-2" @click="changePassword('password-form')">
                      <v-icon small left>fas fa-save</v-icon>
                      {{ $t("global.save") }}
                    </v-btn>
                  </v-flex>
                </v-card-text>
              </v-form>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </v-card>
    </v-container>
  </v-container>
</template>

<script>
export default {
  name: "UserProfile",
  props: ["id"],
  data() {
    return {
      page_title: this.$t("users.profile"),
      user: {},
      old_password: "",
      password: "",
      password_confirmation: "",
      options: {
        edit: false
      },
      dictionary: {
        attributes: {
          email: this.$t("users.email"),
          password: this.$t("users.password"),
          new_pass: this.$t("users.edit.new_pass"),
          old_pass: this.$t("users.edit.old_pass"),
          confirm_pass: this.$t("users.edit.confirm_pass"),

          first_name: this.$t("users.first_name"),
          middle_name: this.$t("users.middle_name"),
          last_name: this.$t("users.last_name"),
          mobile: this.$t("users.mobile")
        }
      }
    }
  },

  created() {
    let user = localStorage.getItem("__crrntUser")
    this.user = JSON.parse(user)
  },
  computed: {
    isPasswordMatch() {
      return this.password == this.password_confirmation ? true : false
    },
    binding() {
      const binding = {}

      if (this.$vuetify.breakpoint.mdAndUp) binding.column = true

      return binding
    }
  },
  methods: {
    update(scope) {
      this.$validator.validate()

      this.$validator
        .validateAll(scope)
        .then((valid) => {
          if (valid) {
            let vm = this

            axios
              .post(this.API_URL + "user/profile/update", {
                id: vm.user.id,
                email: vm.user.email,
                first_name: vm.user.person.first_name,
                middle_name: vm.user.person.middle_name,
                last_name: vm.user.person.last_name,
                mobile: vm.user.person.mobile
              })
              .then((res) => {
                vm.$awn.success(vm.$t("global.update_success"))
              })
              .catch((err) => {
                vm.$awn.success(vm.$t("global.update_failed"))
                console.log(err)
              })

            vm.options.edit = false
          }
        })
        .catch(() => {})
    },
    toggleEdit() {
      this.options.edit == false ? (this.options.edit = true) : (this.options.edit = false)
    },
    changePassword(scope) {
      this.$validator.validate()

      this.$validator
        .validateAll(scope)
        .then((valid) => {
          if (valid && this.isPasswordMatch) {
            let vm = this

            axios
              .post(this.API_URL + "user/changepassword", {
                old_pass: vm.old_password,
                password: vm.password,
                id: vm.user.id
              })
              .then((res) => {
                if (res.data.status == 200) {
                  vm.$awn.success(vm.$t("users.edit.password_success"))
                  setTimeout(function () {
                    vm.$router.go()
                  }, 1500)
                } else {
                  vm.$awn.alert(vm.$t("users.edit.password_error"))
                  vm.old_password = ""
                  vm.password = ""
                  vm.password_confirmation = ""
                }
              })
              .catch((err) => console.log(err))
          }
        })
        .catch(() => {})
    },
    mounted() {
      this.$validator.localize(this.$getSetting("locale"), this.dictionary)
    },
    phoneNoSpace() {
      if (this.user.person.mobile) {
        this.user.person.mobile = this.user.person.mobile.replace(/\s/g, "")
        let field = this.errors.items.find((i) => i.field == "mobile" && i.rule == "no_space")
        if (field) this.$validator.errors.removeById(field.id)
      }
    }
  }
}
</script>
